import React, { RefObject, useCallback, useMemo } from 'react';
import { ThemeProvider } from 'styled-components';

import { btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';

import { graphicData } from '~/src/features/yandex-landing/data';
import { dataLayerPushWrap } from '~/src/features/yandex-landing/utils';
import { useScroll } from '~/src/helpers/hooks/useScroll';

import * as ST from './styled';

const PlusesBlock: React.FC<{ callbackRef: RefObject<HTMLDivElement>, stationMaxi: Object, stationLight: Object }> =
    ({ callbackRef, stationMaxi, stationLight }) => {
    const scrollToRef = useScroll();

    const imageUrl = '/static/images/yandex-landing/rectangle.png';

    const getPrice = useCallback((array) => {
        return array?.pricesV2?.reduce((prev: any, curr: any) => prev.value < curr.value ? prev : curr, [0]);
    }, []);

    const priceMaxi = useMemo(() => {
        const price = getPrice(stationMaxi);
        return price?.duration ? price?.value : null;
    }, [stationMaxi]);

    const priceLight = useMemo(() => {
        const price = getPrice(stationLight);
        return price?.duration ? price?.value : null;
    }, [stationLight]);

    const onScrollWrapper = useCallback(() => {
        dataLayerPushWrap({ label: 'want station', callback: () => scrollToRef(callbackRef) });
    }, []);

    return (
        <ST.PlusesContainer>
            <ST.PlusesTitle> Ваши плюсы уже ждут:</ST.PlusesTitle>
            <ST.GraphicBlock>
                {graphicData.map((elem, key) => (
                    <ThemeProvider theme={{ initialTypeIsRow: elem.initialTypeIsRow }} key={elem.id}>
                        <ST.GraphicItem gradient={elem.gradient} layoutImg={elem.layoutImg} area={elem.area}>
                            {elem.label
                                ? <>
                                    <ST.StepAround>{++key}</ST.StepAround>
                                    <ST.WrapperTop>
                                        <ST.Label imgUrl={elem.label}/>
                                    </ST.WrapperTop>
                                </>
                                : <ST.StepAround>{++key}</ST.StepAround>}
                            <ST.ContentWrap>
                                <ST.ImgBlock hasImgStyle={elem.hasImgStyle} imgUrl={elem.imgUrl}>
                                    {key === 3 && priceMaxi && <ST.PriceMaxiBlock
                                        imgUrl={imageUrl}>
                                            {priceMaxi + ' ₽/мес'}
                                        </ST.PriceMaxiBlock>}
                                    {key === 3 && priceLight && <ST.PriceLightBlock
                                            imgUrl={imageUrl}>
                                            {priceLight + ' ₽/мес'}
                                        </ST.PriceLightBlock>}
                                </ST.ImgBlock>
                                <ST.TextBlock>
                                    <ST.Title $withIndent={false}>{elem.title}</ST.Title>
                                    <ST.SubText>{elem.subText}</ST.SubText>
                                </ST.TextBlock>
                            </ST.ContentWrap>
                        </ST.GraphicItem>
                    </ThemeProvider>
                ))}
            </ST.GraphicBlock>
            <ST.WantButton
                type={btnTypes.ACCENT}
                text={'Хочу Яндекс.Станцию'}
                onClick={onScrollWrapper}
            />
        </ST.PlusesContainer>
    );
};

export default PlusesBlock;
